import { ProgressBar as ProgressBar$1, Item } from './ProgressBar.js';

/**
 * Collection of ProgressBar related components.
 */
const ProgressBar = Object.assign(ProgressBar$1, {
  Item
});

export { ProgressBar };
